import type { AuthLogo } from '@today/ui-domain'
import { useBrandIdentity } from '@today/ui-primitives'

/**
 * The bound brand's logo for the sign-in surfaces (TO-361 login-surface): the
 * pre-auth platform brand that `AppBrandRoot` binds. Its alt is the brand name (REQ-001).
 */
export function useAuthLogo(): AuthLogo {
	const identity = useBrandIdentity()
	return { src: identity.assets.logo.src, alt: identity.name }
}
